/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
module App.HiLO.Controllers {

    'use strict';

    class SupportController extends App.Common.Controllers.ScreenControllerBase {
        public static $inject = ['$injector'];
        public busyPromise: angular.IPromise<any>;
        public id: string;
        public product: string;

        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.title = 'Property Consents';

            this.busyPromise = this.$q.resolve();

        }
       

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {
            return this.$q.resolve();
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.supportController', SupportController);

}